import { render, staticRenderFns } from "./AddPatrolPoints.vue?vue&type=template&id=c3392290&scoped=true"
import script from "./AddPatrolPoints.vue?vue&type=script&lang=js"
export * from "./AddPatrolPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3392290",
  null
  
)

export default component.exports